export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const numberToMonth = (index: number, months: string[]): string => {
    return (typeof (index) === 'number' && months[index]) ? months[index] : '';
};

export const getOrdinalIndicator = (date: number): string => {
    if (typeof (date) !== 'number') { return ''; }

    const defaultOrdinal = 'th';

    if (date >= 11 && date <= 13) {
        return defaultOrdinal;
    }

    const mod = date % 10;

    let resultOrdinal = '';

    switch (mod) {
        case 1: {
            resultOrdinal = 'st';
            break;
        }
        case 2: {
            resultOrdinal = 'nd';
            break;
        }
        case 3: {
            resultOrdinal = 'rd';
            break;
        }
        default: {
            resultOrdinal = defaultOrdinal;
            break;
        }
    }

    return resultOrdinal;
};

export const isValidDate = (theDate: number, theMonth: number, theYear: number): boolean => {
    /**
     * https://stackoverflow.com/a/36305824
     */

    // Check value of parameters
    if (typeof (theDate) !== 'number' || theDate <= 0) { return false; }
    if (typeof (theMonth) !== 'number' || theMonth < 0) { return false; }
    // 2 digits or less for year will be interpret as 19XX, e.g., 98 is 1998, 7 is 1907
    if (typeof (theYear) !== 'number' || theYear < 100) { return false; }

    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    const isLeap = new Date(theYear, 1, 29).getDate() === 29;

    if (isLeap) {
        daysInMonth[1] = 29;
    }

    return theDate <= daysInMonth[theMonth];
};

export const isFutureDate = (theDate: number, theMonth: number, theYear: number): boolean => {
    return new Date(theYear, theMonth, theDate, 23, 59, 59, 999).getTime() > new Date().getTime();
};
